import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import AppLayout from './components/AppLayout';

Vue.config.productionTip = false
Vue.component('app-layout', AppLayout);

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
